import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../common/dialogWrapper";
import { Box } from "@mui/material";
import { LanguageService } from "../../../services/languageService";

export const HowItWorksDialog = ({ showHowWorks = false, onClose = (e) => { } }) => {
  const languageService = new LanguageService();
  const isAr = () => languageService.isArabic();

  const { t } = useTranslation();
  return <DialogWrapper
    dialogClass='how-it-works-popup'
    titleClass="!w-full !items-center"
    maxWidth="md"
    state={showHowWorks}
    onClose={() => {
      onClose(false);
    }}
    title={t('howItWorks')}
    content={
      <Box className="!text-sm text-center">
        <iframe title='how it works' src={`https://www.youtube.com/embed/${isAr() ? '3il8m_7Bhfg' : '_su-Cj64yRc'}?autoplay=1&showinfo=0`}
          style={{ border: '0px' }}
          className='md:!min-h-[500px] min-h-[330px]'
          name="howitworks" scrolling="no"
          frameborder="1" marginheight="0px"
          marginwidth="0px" height="100%" width="100%"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </Box>
    }
  ></DialogWrapper>;
};